import { isWretchError, type TConstraints, wretch } from '@feathr/rachis';

import Session from '../Session';
import { TargetableClass } from './targetable.types';
import type { ITargetableBase } from './targetable_base';
import { TargetableBase } from './targetable_base';

export const Categories = [
  {
    label: 'Industry',
    options: [
      { id: 468, name: 'Industry' },
      { id: 473, name: 'Industry / Agriculture & Forestry' },
      { id: 474, name: 'Industry / Arts & Entertainment' },
      { id: 475, name: 'Industry / Automotive' },
      { id: 476, name: 'Industry / Business & Finance' },
      { id: 477, name: 'Industry / Computers & Technology' },
      { id: 478, name: 'Industry / Construction' },
      { id: 479, name: 'Industry / Consumer Services' },
      { id: 480, name: 'Industry / Education' },
      { id: 481, name: 'Industry / Government' },
      { id: 482, name: 'Industry / Health Care' },
      { id: 483, name: 'Industry / Manufacturing' },
      { id: 484, name: 'Industry / Real Estate' },
      { id: 485, name: 'Industry / Retail & Shopping' },
      { id: 486, name: 'Industry / Services' },
      { id: 488, name: 'Industry / Travel' },
      { id: 508, name: 'Industry / Small Business' },
      { id: 490, name: 'Industry / Occupation' },
      { id: 491, name: 'Industry / Occupation / Accounting & Finance' },
      { id: 492, name: 'Industry / Occupation / Administrative' },
      { id: 493, name: 'Industry / Occupation / Agriculture & Manufacturing' },
      { id: 494, name: 'Industry / Occupation / Blue Collar' },
      { id: 495, name: 'Industry / Occupation / Business Owner' },
      { id: 496, name: 'Industry / Occupation / Construction' },
      { id: 497, name: 'Industry / Occupation / Education' },
      { id: 498, name: 'Industry / Occupation / Engineering' },
      { id: 499, name: 'Industry / Occupation / Government' },
      { id: 500, name: 'Industry / Occupation / Health' },
      { id: 501, name: 'Industry / Occupation / Job Search' },
      { id: 502, name: 'Industry / Occupation / Legal' },
      { id: 503, name: 'Industry / Occupation / Management' },
      { id: 504, name: 'Industry / Occupation / Military' },
      { id: 505, name: 'Industry / Occupation / Sales & Marketing' },
      { id: 506, name: 'Industry / Occupation / Technical' },
      { id: 507, name: 'Industry / Occupation / White Collar' },
    ],
  },
  {
    label: 'Demographic',
    options: [
      { id: 524, name: 'Demographic' },
      { id: 532, name: 'Demographic / Education' },
      { id: 533, name: 'Demographic / Education / Area Of Study' },
      { id: 534, name: 'Demographic / Education / Colleges & Universities' },
      { id: 535, name: 'Demogrphic / Education / Level Of Education' },
    ],
  },
  {
    label: 'In-Market',
    options: [
      { id: 600, name: 'In-Market' },
      { id: 601, name: 'In-Market / Arts & Entertainment' },
      { id: 602, name: 'In-Market / Arts & Entertainment / Events' },
      { id: 603, name: 'In-Market / Arts & Entertainment / Music' },
      { id: 604, name: 'In-Market / Arts & Entertainment / Tv & Movies' },
      { id: 605, name: 'In-Market / Autos' },
      { id: 606, name: 'In-Market / Autos / Auto Parts' },
      { id: 607, name: 'In-Market / Autos / Boats' },
      { id: 647, name: 'In-Market / Autos / Class / Economical' },
      { id: 648, name: 'In-Market / Autos / Class / Full-Size' },
      { id: 649, name: 'In-Market / Autos / Class / Hybrid' },
      { id: 650, name: 'In-Market / Autos / Class / Mid-Size' },
      { id: 651, name: 'In-Market / Autos / Class / Other' },
      { id: 652, name: 'In-Market / Autos / Class / Sports Cars' },
      { id: 653, name: 'In-Market / Autos / Class / Trucks & Suvs' },
      { id: 654, name: 'In-Market / Autos / Class / Vans' },
      { id: 655, name: 'In-Market / Autos / Finance & Insurance' },
      { id: 656, name: 'In-Market / Autos / Motorcycles' },
      { id: 657, name: 'In-Market / Autos / Used' },
      { id: 659, name: 'In-Market / Beauty' },
      { id: 660, name: 'In-Market / Beauty / Cosmetics' },
      { id: 661, name: 'In-Market / Beauty / Hair Care' },
      { id: 662, name: 'In-Market / Beauty / Personal Care' },
      { id: 663, name: 'In-Market / Beauty / Skin Care' },
      { id: 664, name: 'In-Market / Books & Literature' },
      { id: 665, name: 'In-Market / Business' },
      { id: 666, name: 'In-Market / Computers & Technology' },
      { id: 667, name: 'In-Market / Computers & Technology / Audio & Video' },
      { id: 669, name: 'In-Market / Computers & Technology / Cameras & Camcorders' },
      { id: 670, name: 'In-Market / Computers & Technology / Cell Phones' },
      { id: 671, name: 'In-Market / Computers & Technology / Computers' },
      { id: 672, name: 'In-Market / Computers & Technology / Tv & Home Theater' },
      { id: 673, name: 'In-Market / Education' },
      {
        id: 674,
        name: 'In-Market / Education / Area Of Study',
      },
      { id: 675, name: 'In-Market / Education / School Location' },
      {
        id: 676,
        name: 'In-Market / Fashion & Style',
      },
      {
        id: 677,
        name: 'In-Market / Fashion & Style / Accessories',
      },
      {
        id: 679,
        name: 'In-Market / Fashion & Style / Clothing',
      },
      { id: 690, name: 'In-Market / Fashion & Style / Footwear' },
      { id: 691, name: 'In-Market / Fashion & Style / Jewelry' },
      {
        id: 692,
        name: 'In-Market / Finance',
      },
      {
        id: 713,
        name: 'In-Market / Games',
      },
      { id: 715, name: 'In-Market / Health' },
      { id: 716, name: 'In-Market / Hobbies & Leisure' },
      {
        id: 717,
        name: 'In-Market / Home & Garden',
      },
      {
        id: 718,
        name: 'In-Market / Home & Garden / Bed & Bath',
      },
      { id: 719, name: 'In-Market / Home & Garden / Home Furnishing' },
      { id: 720, name: 'In-Market / Home & Garden / Home Improvement' },
      {
        id: 722,
        name: 'In-Market / Home & Garden / Kitchen & Appliances',
      },
      { id: 723, name: 'In-Market / Home & Garden / Outdoor & Patio' },
      {
        id: 724,
        name: 'In-Market / Outdoor & Recreation',
      },
      {
        id: 725,
        name: 'In-Market / Outdoor & Recreation / Camping & Hiking',
      },
      { id: 726, name: 'In-Market / Outdoor & Recreation / Cycling' },
      { id: 727, name: 'In-Market / Outdoor & Recreation / Fishing & Game' },
      { id: 728, name: 'In-Market / Pets & Animals' },
      {
        id: 743,
        name: 'In-Market / Real Estate',
      },
      {
        id: 745,
        name: 'In-Market / Retail & Shopping',
      },
      {
        id: 754,
        name: 'In-Market / Sports',
      },
      { id: 755, name: 'In-Market / Sports / Individual Sports' },
      { id: 756, name: 'In-Market / Sports / Sports Brands' },
      { id: 757, name: 'In-Market / Sports / Water Sports' },
      { id: 758, name: 'In-Market / Sports / Winter Sports' },
      {
        id: 759,
        name: 'In-Market / Travel',
      },
      {
        id: 760,
        name: 'In-Market / Travel / Car Rentals',
      },
      { id: 762, name: 'In-Market / Travel / Cruises' },
      {
        id: 779,
        name: 'In-Market / Travel / Flights',
      },
      {
        id: 783,
        name: 'In-Market / Travel / Hotels',
      },
      {
        id: 789,
        name: 'In-Market / Travel / Vacation',
      },
    ],
  },
];

export const getTopLevelCategories = (): number[] => {
  return Categories.map((category) => category.options[0].id);
};

/**
 * Interface for affinity targetables
 */
export interface IAffinityTargetable extends ITargetableBase {
  _cls: TargetableClass.affinity;
  audience_inactive: boolean;
  category_id: number;
  description?: string;
  // Specific audience properties within a category
  full_path?: string;
  thirdparty_data_id?: string;
  thirdparty_brand_name?: string;
  thirdparty_data_name?: string;
  unique_user_count?: number;
}

export interface IThirdPartyDataOption {
  ThirdPartyDataId: string;
  Name: string;
  BrandName: string;
  ActiveIDsCount: number;
  FullPath: string;
  Description: string;
}

/**
 * AffinityTargetable class for affinity targetables
 */
export class AffinityTargetable extends TargetableBase<IAffinityTargetable> {
  public static override readonly defaults: Partial<IAffinityTargetable> = {
    audience_inactive: false,
  };

  public override className = 'Targetable.AffinityTargetable';

  public override get constraints(): TConstraints<IAffinityTargetable> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [TargetableClass.affinity],
      },
      // Affinity doesn't require name
      name: undefined,
      thirdparty_data_id: {
        presence: {
          allowEmpty: false,
          message: '^Choose an affinity audience for your Target.',
        },
      },
      audience_inactive: (...args: unknown[]): TConstraints<IAffinityTargetable> | undefined => {
        const attributes = args[1] as IAffinityTargetable;
        const { thirdparty_data_id } = attributes;

        if (thirdparty_data_id) {
          return {
            inclusion: {
              // Requires audience_inactive to be false
              within: [false],
              message: '^Affinity audience unavailable. You must select a different audience.',
            },
          };
        }
        return undefined;
      },
    };
  }

  public override getDefaults(): Partial<IAffinityTargetable> {
    return {
      ...super.getDefaults(),
      _cls: TargetableClass.affinity,
      ...AffinityTargetable.defaults,
    };
  }

  public async getPaginatedThirdPartyData({
    inputValue,
    page = 0,
    pageSize = 100,
    showAllAffinityAudiences = false,
  }): Promise<{ options: IThirdPartyDataOption[]; hasMore: boolean }> {
    // If not prod, allow all categories so the feature is testable
    // None of our categories will yield audience results, but we can at least select audiences
    const categories = showAllAffinityAudiences
      ? `cat=""`
      : `cat=${getTopLevelCategories().join(',')}`;

    // Allow the user to skip selecting a category id
    const category = this.get('category_id') ? `cat=${this.get('category_id')}` : categories;

    // audience_type=affinity opts into the BE filter that drops non-affinity
    // BrandIds (e.g. CrossPixel custom audiences). See Feathr/anhinga#7385.
    const url = `${BLACKBOX_URL}targetables/thirdpartydata?${category}&audience_type=affinity&page[page]=${page}&page[page_size]=${pageSize}&term=${encodeURIComponent(
      inputValue || '',
    )}`;

    const headers = {
      ...Session.getHeaders(),
    };
    const response = await wretch<{ Result: IThirdPartyDataOption[]; HasMore?: boolean }>(url, {
      headers,
      method: 'GET',
    });

    if (isWretchError(response)) {
      throw response.error;
    }

    /*
     * thirdpartydata is a passthrough for the upstream affinity provider and
     * returns `{ Result, HasMore }` directly, not inside wretch's standard
     * `{ data }` envelope. Read from whichever shape is present so a missing
     * envelope doesn't throw "Cannot read properties of undefined (reading
     * 'Result')". See Feathr/shrike#8445.
     */
    const payload = (response.data ?? response) as {
      Result?: IThirdPartyDataOption[];
      HasMore?: boolean;
    };
    const options = payload?.Result ?? [];

    return {
      options,
      // Prefer the BE-supplied HasMore (raw-count based, correct after filter).
      // Fall back to length heuristic in case of partial deploy or stale cache.
      hasMore: payload?.HasMore ?? options.length >= pageSize,
    };
  }
}
